

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EditQuoteModel } from '../model/edit-quote-modal';



@Injectable()
export class JsonControlService {
    editQuoteModel: EditQuoteModel;
    constructor() { }

    private summons = new BehaviorSubject<EditQuoteModel[]>([]);
    public summons$ = this.summons.asObservable();

    setSummon(data: EditQuoteModel[]) {
        this.summons.next(data);
    }
}

